import * as tslib_1 from "tslib";
import { OnInit, Renderer2 } from '@angular/core';
import { FormGroupDirective, Validators } from '@angular/forms';
import { FormComponent } from '../../../core/base/form-component';
import { FormsService } from '../../../core/services/forms.service';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
var ForgotAccountPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ForgotAccountPageComponent, _super);
    function ForgotAccountPageComponent(forms, store, renderer, route) {
        var _this = _super.call(this) || this;
        _this.forms = forms;
        _this.store = store;
        _this.renderer = renderer;
        _this.route = route;
        _this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
        _this.form = _this.forms.group({
            email: [
                '', [Validators.required, Validators.email], 'forgot.fields.email'
            ]
        });
        return _this;
    }
    ForgotAccountPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        // add login class to body for background image
        this.renderer.addClass(document.body, 'login');
        this.route.queryParams.pipe(filter(function (params) { return params.email; })).subscribe(function (params) {
            _this.form.patchValue({
                email: params.email
            });
        });
    };
    ForgotAccountPageComponent.prototype.ngOnDestroy = function () {
        // remove login class
        this.renderer.removeClass(document.body, 'login');
    };
    return ForgotAccountPageComponent;
}(FormComponent));
export { ForgotAccountPageComponent };
